import { useAssigneeFilter } from '../../../hooks/useAssigneeFilter';
import type { DmMessageInboxFilters } from '../../../services/dmMessagesInbox';
import { ASSIGNEE_NULL_SENTINEL } from '../../../utils/assigneeFilter';
import { tagsToVersions } from '../shared/inboxTags';
import type { MessageListParams } from './messageListParams';

// The list's URL filter values as the API takes them: "Me" to an email, unknown tags dropped.
export function useMessageApiFilters(
    { search, practiceIds, assignees, tags, status, sort, order }: MessageListParams,
    onAssigneesMigrate?: (values: string[]) => void
) {
    const {
        options: assigneeOptions,
        apiValues: apiAssignees,
        settled: assigneesResolved
    } = useAssigneeFilter(assignees, ASSIGNEE_NULL_SENTINEL, onAssigneesMigrate);
    const apiFilters: DmMessageInboxFilters = {
        sort,
        order,
        search: search || undefined,
        practiceIds,
        assignees: apiAssignees,
        versions: tagsToVersions(tags),
        status
    };
    return { apiFilters, assigneeOptions, assigneesResolved };
}
